import styled, { css } from 'styled-components';

import { hexWithAlpha } from 'utils/colors';

export const BadgeRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.8rem;
  padding-top: 0.2rem;
`;

const VARIANT_STYLES = {
  gold: css`
    background: ${({ theme }) => theme.colors.trustBadgeGoldBg};
    border: 0.1rem solid ${({ theme }) => theme.colors.trustBadgeGoldBorder};
    color: ${({ theme }) => theme.colors.trustBadgeGoldFg};
  `,
  purple: css`
    background: ${({ theme }) => theme.colors.trustBadgePurpleBg};
    border: 0.1rem solid ${({ theme }) => theme.colors.trustBadgePurpleBorder};
    color: ${({ theme }) => theme.colors.trustBadgePurpleFg};
  `,
  green: css`
    background: ${({ theme }) => theme.colors.trustBadgeGreenBg};
    border: 0.1rem solid ${({ theme }) => theme.colors.trustBadgeGreenBorder};
    color: ${({ theme }) => theme.colors.trustBadgeGreenFg};
  `,
};

// The "green" badge (Open to collabs / Open for Bookings) is the one that
// follows the provider's chosen brand accent on the real profile page — gold
// and purple stay fixed trust signals regardless of brand color.
export const Badge = styled.div<{ $variant: LandingV2.TrustBadgeVariant; $accentColor?: string | null }>`
  ${({ $variant }) => VARIANT_STYLES[$variant]}
  ${({ $variant, $accentColor }) =>
    $variant === 'green' &&
    $accentColor &&
    css`
      background: ${hexWithAlpha($accentColor, 0.12)};
      border-color: ${hexWithAlpha($accentColor, 0.32)};
      color: ${$accentColor};
    `}
  font-size: 1.2rem;
  font-weight: 800;
  padding: 0.8rem 1.4rem;
  border-radius: 999rem;
  white-space: nowrap;
  transition:
    background-color 0.15s ease,
    border-color 0.15s ease,
    color 0.15s ease;
`;
